import React, { useState } from 'react'
import { Button, Table, Typography, Space, Image, Form, Row, Col, Flex, Card } from 'antd'
import { projecdetailData } from '../../../Data';
import { ActionButton, AlertModal, ModuleTopHeading, SearchInput } from '../../../components';

const { Text } = Typography;
const ProjectDetailtable = () => {

    const [deleteitem,setDeleteItem] = useState(false)
    const [form] = Form.useForm();


    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Project Name</Text>,
            dataIndex: 'projectname',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Client Name</Text>,
            dataIndex: 'clientName'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Budget ($)</Text>,
            dataIndex: 'budget'

        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Start Date</Text>,
            dataIndex: 'startdate'

        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>End Date</Text>,
            dataIndex: 'enddate'

        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Status</Text>,
            dataIndex: 'status',
            render: (status) => {
                if (status === 'Completed') {
                    return <Text className='active fs-12 badge-cs'>Completed</Text>;
                } else {
                    return <Text className='inactive fs-12 badge-cs'>Ongoing</Text>;
                }
            },
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            align: 'center',
            width: 100,
            render: (_, row) => (
                <Space>
                    <ActionButton
                        title='Delete Client'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.firstName})}}
                    />
                </Space>
            ),
        },
    ];
    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical gap={20}>
                            <ModuleTopHeading level={4} name='Project Details'/>
                            <Form
                                form={form}
                                layout="vertical"
                            >
                                <Row gutter={[16,16]} align={'middle'}>
                                    <Col lg={8} md={12} sm={24} xs={24}>
                                        <SearchInput 
                                            name='name'
                                            placeholder='Search'
                                            value={form.getFieldValue('name') || ''}
                                            prefix={<img src='/assets/icons/search.png' width={20} />}
                                            className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <Table
                            size='large'
                            columns={columns}
                            dataSource={projecdetailData}
                            className='pagination'
                            showSorterTooltip={false}
                            scroll={{ x: 1300 }}
                            pagination={{
                                hideOnSinglePage: true,
                                total: 12,
                                // pageSize: pagination?.pageSize,
                                // defaultPageSize: pagination?.pageSize,
                                // current: pagination?.pageNo,
                                // size: "default",
                                // pageSizeOptions: ['10', '20', '50', '100'],
                                // onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                                showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
                            }}
                        />
                    </Col>
                </Row>
            </Card>
            <AlertModal
                visible={deleteitem}
                deleteitem={deleteitem}
                onClose={()=>{setDeleteItem(false)}}
            />
        </>
    )
}

export { ProjectDetailtable }